import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  inject,
  input,
  NgZone,
  OnInit,
  output,
  PLATFORM_ID
} from '@angular/core';
import {ScriptService} from '@core/services/script.service';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '@env/environment';

@Component({
  selector: 'div[app-orbitvu-360]',
  templateUrl: './orbitvu-360.component.html',
  styleUrl: './orbitvu-360.component.scss',
  'host': {ngSkipHydration: 'true'},
})
export class Orbitvu360Component implements OnInit {
  protected scriptService = inject(ScriptService);
  protected platformId = inject(PLATFORM_ID);
  protected changeDetectorRef = inject(ChangeDetectorRef);
  protected zone = inject(NgZone);

  productVismaId = input.required<string>();
  isModal = input(false);
  orbitvuError = output<void>();

  @HostBinding('attr.id')
  get hostId() {
    return 'ovContent-' + (this.isModal() ? '-modal-' : '') + this.productVismaId();
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const imageUrl = environment.supervin['360ImageUrl'] + '/' + this.productVismaId() + '_flaske/';
    this.zone.runOutsideAngular(() => {
      this.scriptService.addScript({
        type: 'text/javascript',
        src: imageUrl + '/orbitvu12/orbitvu.js',
        async: true
      }).then(() => {
        // To prevent angular rerender this component, we need to detach the change detector
        this.changeDetectorRef.detach();
        console.log('orbitvu script loaded');

        const test = (window as any).inject_orbitvu(
          this.hostId,
          imageUrl,
          '',
          {
            'frame_rate': '12',
            'background_color': '0xffffff00',
            'border_color': '0x00000000',
            'preload': 'no',
            'teaser': 'static',
            'style': '4',
            'gui_background': '0x000000c8',
            'gui_foreground': '0xffffffc8',
            'gui_foreground_active': '0x00b5a7c8',
            'lang': 'en',
            'auto_rotate_dir': 'right',
            'rotate_dir': 'auto',
            'vmove': 'yes',
            'ovskin': 'no',
            'border': 'no',
            'html5_initial_info': 'no',
            'html5_hint': 'yes',
            'vmove_dir': 'down',
            'max_scale': '1',
            'width': '100%',
            'height': '100%',
            'mousewheel': 'yes',
            'color_theme': '',
            'report_bugs': 'no',
            'social_url': imageUrl + '/1150020221_flaske.html',
            'auto_drag_switch': 'yes',
            'partial_load': 'yes',
            'hires_forced_zoom': 'yes',
            'viewer_base': imageUrl + 'orbitvu12/',
            'ovus_folder': imageUrl,
            'content2': 'yes',
            'use_config_url': 'no',
            'ovus_cache_modifier': 'a66c3026a36191f8d3e154156f51ff25'
          }
        );
        console.log(test);
      }).catch(error => {
        console.error('Error loading orbitvu script:', error);
        this.orbitvuError.emit();
      })
    })

  }


}
